export default {"src":"/_next/static/media/pdf_64.ff44f38c.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};